import * as React from 'react';

const AccommodationLocation = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} viewBox="0 0 22 22" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
            transform="translate(1 1)"
        >
            <path d="M9.375 15.193v2.932c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-2.932M19.375 14.568l-5.417-4.872a1.25 1.25 0 0 0-1.671 0L6.87 14.568M18.125 13.443V10" />
            <circle cx={6.875} cy={6.875} r={3.125} />
            <path d="M6.875 19.375a.62.62 0 0 1-.52-.28C4.852 16.833.624 9.715.624 6.875a6.25 6.25 0 1 1 12.5 0" />
        </g>
    </svg>
);
export default AccommodationLocation;
